import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useImmer } from "use-immer";

import { ColorPrimary, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useGetOrg } from "../../../../api/organizations/get-organization";
import { TestIdeasAiButton } from "../../../../components/Buttons/TestIdeasAiButton";
import { CheckoutScriptDialog } from "../../../../components/Dialogs/CheckoutScriptDialog";
import { CreateExperienceTestDialog } from "../../../../components/Dialogs/CreateExperienceTestDialog";
import { CreateShippingErrorDialog } from "../../../../components/Dialogs/CreateShippingErrorDialog";
import { RedirectToPluginDialog } from "../../../../components/Dialogs/RedirectToPluginDialog";
import { StartShippingErrorDialog } from "../../../../components/Dialogs/StartShippingErrorDialog";
import { StartTestDialog } from "../../../../components/Dialogs/StartTestDialog";
import { ThirdPartyCarrierWarningDialog } from "../../../../components/Dialogs/ThirdPartyCarrierWarningDialog";
import { Resources } from "../../../../components/MainApp/Utils/Resources";
import {
  checkAnyScope,
  checkBooleanScope,
} from "../../../../components/ScopeWrappers/helpers";
import { ScopedButton } from "../../../../components/ScopeWrappers/ScopedButton";
import { ScreenshotRecommendationsPanel } from "../../../../components/screenshotRecommendationsPanel";
import { useViewPage } from "../../../../hooks/mixpanel";
import { useWebsocket } from "../../../../hooks/websocket";
import {
  resetExperienceListFilters,
  selectedExperienceListFilters,
  setUseAppPadding,
  setUseWideApp,
} from "../../../../store/slices/appSettings";
import { setDialog } from "../../../../store/slices/global";
import {
  ExperienceListFiltersType,
  initialExperienceListFilters,
} from "../../../../types/experience";
import { mpClickCreateExperienceButton } from "../../../../utils/mixpanel";

import { ExperienceListHeader } from "./components/ExperienceListHeader";
import { ExperiencesList } from "./components/experiencesList";
import { ScheduleTestDialog } from "./components/scheduleTestDialog/ScheduleTestDialog";

export const ExperiencesHomeRoute = memo(function Experiments() {
  const organization = useGetOrg();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const experienceListFilters = useSelector(selectedExperienceListFilters);

  const { lastJsonMessage } = useWebsocket(organization.data?.org.id);

  useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === "productVariantStatus") {
      // setTestStatus((draft) => {
      //   if (!(lastJsonMessage.variantId in draft)) {
      //     draft[lastJsonMessage.variantId] = {};
      //   }
      //
      //   if (typeof lastJsonMessage.eventStatus === "string") {
      //     draft[lastJsonMessage.variantId][lastJsonMessage.testGroupId] =
      //       lastJsonMessage.eventStatus;
      //   }
      //   return draft;
      // });
    }
  }, [lastJsonMessage]);

  useViewPage("Home");

  useEffect(() => {
    dispatch(setUseWideApp(false));
  }, []);

  useEffect(() => {
    dispatch(setUseAppPadding(true));
  }, []);

  return (
    <Grid container direction={"column"} spacing={3}>
      <Grid
        item
        xs
        container
        direction={"row"}
        justifyContent={"space-between"}
        flexWrap={"nowrap"}
        alignItems={"center"}
      >
        <Grid container item>
          <Grid item>
            <IgTypography
              sx={{
                letterSpacing: "0.5px",
                fontSize: "23px",
                fontWeight: 600,
                lineHeight: "110%",
              }}
            >
              A/B Tests Overview
            </IgTypography>
          </Grid>
        </Grid>
        <Grid container item justifyContent={"end"} columnSpacing={2}>
          <Grid item>
            <TestIdeasAiButton />
          </Grid>
          <Grid item>
            <ScopedButton
              sx={{ width: "160px" }}
              customBackgroundColor={ColorPrimary.main}
              variant="contained"
              debugId={"create-new-exp-button"}
              onClick={() => {
                dispatch(setDialog({ dialog: "createExperiment", open: true }));
                mpClickCreateExperienceButton();
              }}
              isEnabled={checkAnyScope([
                checkBooleanScope(
                  "create_price_experiment",
                  organization.data.org.configurations
                ),
                checkBooleanScope(
                  "create_shipping_experiment",
                  organization.data.org.configurations
                ),
              ])}
            >
              Create New Test
            </ScopedButton>
          </Grid>
        </Grid>
      </Grid>
      {experienceListFilters && (
        <Grid item>
          <ExperienceListHeader />
        </Grid>
      )}
      <Grid item xs>
        <ExperiencesList />
      </Grid>
      <Grid item>
        <ScreenshotRecommendationsPanel />
      </Grid>
      <Grid item xs>
        <Resources />
      </Grid>
      <CreateExperienceTestDialog />
      <CreateShippingErrorDialog />
      <StartShippingErrorDialog />
      <StartTestDialog />
      <CheckoutScriptDialog />
      <ThirdPartyCarrierWarningDialog />
      <ScheduleTestDialog />
      <RedirectToPluginDialog
        type={"experiment"}
        isLoading={false}
        handleClose={() => {
          dispatch(
            setDialog({ dialog: "redirectToPluginDialog", open: false })
          );
        }}
      />
    </Grid>
  );
});
